module.exports = __webpack_public_path__ + "img/icon_search.3a5f37a1.svg";